exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop[data-v-293ac79d]{opacity:.5!important}.pp-coprof-export-check-correction[data-v-293ac79d]{padding-bottom:5px;text-align:left;margin-top:-12px}.pp-coprof-export-check-input[data-v-293ac79d]{border:1px solid #ccc;text-align:center;border-radius:0;padding:7px 5px;margin-top:8px}.pp-btn-search[data-v-293ac79d]{background-color:#f1f1f1;display:flex;justify-content:center;align-items:center;color:#7f7e7e;border-radius:999px;border:1px solid silver;padding:6px;cursor:pointer;width:26px;height:26px;margin-top:30px;\n&[data-v-293ac79d]:hover{background-color:#cacaca;color:#fff}}", ""]);

// exports
